var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.65 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Double_Arrow",
    "data-name": "Double Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrows",
    d: "M96,0l.58,0a5.4,5.4,0,0,1,3.18,1.52l.41.46a5.33,5.33,0,0,1-.41,7.07L12.8,96l87,87,.41.46a5.31,5.31,0,0,1-.41,7.06l-.51.45a5.48,5.48,0,0,1-3,1.1h-.57l-.62-.07a5.18,5.18,0,0,1-2.81-1.44L1.55,99.83l-.47-.57A5.39,5.39,0,0,1,0,96l0-.58a5.29,5.29,0,0,1,1.52-3.21L92.23,1.55A5.33,5.33,0,0,1,96,0Zm53.35,0,.57,0a5.4,5.4,0,0,1,3.18,1.52l.41.46a5.33,5.33,0,0,1-.41,7.07L66.15,96l86.94,87,.41.46a5.31,5.31,0,0,1-.41,7.06l-.51.45a5.45,5.45,0,0,1-3,1.1H149l-.63-.07a5.25,5.25,0,0,1-2.81-1.44L54.89,99.83l-.47-.57A5.46,5.46,0,0,1,53.34,96l0-.58a5.21,5.21,0,0,1,1.52-3.21L145.57,1.55A5.34,5.34,0,0,1,149.34,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrows);
export default __webpack_public_path__ + "static/media/double-arrows.a541f1c7c88e8066da407058e9835341.svg";
export { ForwardRef as ReactComponent };